import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { filterByTextSearch } from '../../packages/kiti/utils/helpers/search'
import { integrationsClient } from '../../utils/apollo/api'
import { usePromiseQuery } from '../../utils/apollo/_helpers/promiseQuery'
import Select from '../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Channels($integrationId: Int) {
    Channels(integrationId: $integrationId) {
      id
      name
    }
  }
`

const useChannelsLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient, fetchPolicy: 'cache-first' })
  return (search, page = 1) => {
    return query(filter) //
      ?.then(pathOr([], ['data', 'Channels']))
      ?.then(channels => filterByTextSearch(channels, search))
  }
}

const SlackChannelSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useChannelsLoader(filter)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      disablePagination
      {...props}
    />
  )
}

export default SlackChannelSelect
